/**
 * Normalize list API responses that may be either a bare array or a
 * paginated object ({ data|users: [], pagination }).
 */
export function unwrapListResponse(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.users)) return payload.users;
  return [];
}

/** Safe client-side page slice; never throws on non-arrays. */
export function slicePage(list, start, end) {
  return Array.isArray(list) ? list.slice(start, end) : [];
}
